<template>
  <div class="basic_wrap">
    <div
      id="red_top_bg"
      class="red_top_bg"
      style="z-index: 10000;background: rgba(0, 0, 0, 0.88) !important;color:fff"
    >
      <div
        class="logo"
        style="display: flex;
		        align-items: center;
		        gap: 10px;
		        font-size: 16px;
		        font-weight: 800;
		        color: #fff;
		        letter-spacing: -0.4px;"
      >
        <div
          class="logo-dot"
          style="width: 32px;
		        height: 32px;
		        border-radius: 9px;
		        overflow: hidden;
		        flex-shrink: 0;
		        display: flex;
		        align-items: center;
		        justify-content: center;"
        >
          <img
            :src="logo"
            alt="logo"
            class="logo-dot-img"
            style="width: 100%;
		        height: 100%;
		        object-fit: cover;
		        display: block;"
          > 
        </div>
        {{ app.name }}
      </div>
      <div
        class="language"
        style="display: flex;
		align-items: center;
		justify-content: center;
		background: transparent;
		border: none;
		padding: 6px;
		cursor: pointer;
		transition: opacity 0.2s;"
      >
        <img
          :src="require('../img/user/kf.png')"
          style=" width: 32px;
		      height: 32px;
		      object-fit: cover;
		      border-radius: 5px;
		      display: block;margin-right: 6px"
          @click="jump(service.kefu)"
        >
        <img
          :src="language_logo"
          style=" width: 32px;
		        height: 32px;
		        object-fit: cover;
		        border-radius: 9px;
		        display: block;"
          @click="$router.push('/language')"
        >
      </div>
    </div>
		
		
    <div
      class="list-header"
      style="margin-top: 80px;"
    >
      <h1>{{ $t('utils.qbjs') }}</h1>
      <div class="sort-btns">
        <span
          class="sort-btn"
          :class="{ active: sortBy === 'hot' }"
          @click="sortBys('hot')"
        >{{ $t('utils.hot1') }}</span>
        <span
          class="sort-btn"
          :class="{ active: sortBy === 'latest' }"
          @click="sortBys('latest')"
        >{{ $t('utils.new') }}</span>
      </div>
    </div>
		
    <div class="genre-scroll-wrap">
      <div class="genre-scroll">
        <span
          v-for="(tab,index) in tabs"
          :key="index"
          class="genre-tag"
          :title="tab.title"
          :class="{ active: tab.id === active }"
          @click="qiehuan(tab.id)"
        >{{ tab.title }}</span>
      </div>
    </div>
    <div
      class="video-grid"
      style="margin-bottom: 80px;"
    >
      <div
        v-for="item in allVideos"
        :key="item.id"
        class="video-card"
        @click="$router.push({ name: 'investOne', params: { code: item.id } })"
      >
        <div
          class="card-thumb"
          :class="item.bgClass"
        >
          <img
            :src="item.img"
            alt=""
            class="thumb-img"
            loading="lazy"
          >
          <div class="play-icon-overlay">
            <div class="circle">
              NEW
            </div>
          </div>
          <span class="duration-badge">{{ item.duration }}</span>
          <span
            v-if="item.isNew"
            class="new-badge"
          >NEW</span>
        </div>
        <div class="card-info">
          <h4>{{ item.title }}</h4>
          <div class="meta-text">
            <span>{{ item.genre }}</span>
            <span class="dot-sep" />
            <span>{{ item.rating }}</span>
          </div>
          <div
            class="meta-text"
            style="margin-top: 5px;"
          >
            <span>{{ $t('utils.ji') }}  {{ item.episodes }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
	import Vue from 'vue';
	import bsHeader from '../../components/bsHeader.vue'
	import Fetch from '../../utils/fetch'
	import {
		Tab,
		Tabs,
		List,
		Empty,
		Lazyload
	} from 'vant';
	Vue.use(Tab).use(Tabs).use(List).use(Empty).use(Lazyload);
	export default {
		name: "Faxian",
		components: {
			bsHeader
		},
		data() {
			return {
				data: [],
				show_tabs:false,
				tabs: [{
						id: 90,
						title: this.$t('tabs.all')
					}

				],
				sortBy: 'latest',
				service:'',
				active: 0,
				empty: false,
				loading: false,
				finished: false,
				list: [],
				page: 1,
				listRows: 8,
				language_logo: localStorage.getItem('language_logo'),
				logo: localStorage.getItem("logo2"),
				tabs: [{
						id: 0,
						title: this.$t('tabs.all')
					}
				
				],
				app: {
					"show": false,
					"name": "",
					"url": "",
					"logo": "",
				},
				allVideos: [
					
				],
			};
		}, computed: {
                filteredRankingList() {
				  const list = this.rankingData[this.activeRankingTab] || this.rankingData.total;
				  return list.map((item, idx) => ({
					  ...item,
					  rank: String(idx + 1).padStart(2, '0')
				  }));
			  },
			  remainingList() {
				  
				  return this.filteredRankingList.slice(3);
			  }
            },
		created() {
			if (window.plus) {
				plus.navigator.setStatusBarBackground('#FAFAFA');
				plus.navigator.setStatusBarStyle('dark');
			}
			this.$parent.footer('faxian', true);
		},
		mounted() {
			if (this.$router.history.current.query.type) {
				this.active = parseInt(this.$router.history.current.query.type);
			}
			
			this.start();
		},
		methods: {
			change(item) {
				// if (item.type == 1) {
				// 	return this.common.precision_basic(item.min * item.rate * item.day / 100);
				// } else {
				// 	return this.common.precision_basic(item.min * item.rate / 100);
				// }
				return this.common.precision_basic(item.min * item.rate / 100);
			},changes(item) {
				return this.common.precision_basic(item.min * item.rate * item.day / 100);
			},
			start() {
				Fetch('/index/item_class').then((r) => {
					var tabs1 = [];
					r.data.classes.forEach(item => {
						tabs1.push({
							id: item.id,
							title: item.title,
						})
					})
					this.tabs = tabs1;
					this.show_tabs = true;
				});
				Fetch('/index/item_juji', {
					page: this.page,
					listRows: this.listRows,
					type: this.active,
					sortBy:this.sortBy,
				}).then(r => {
					
					this.allVideos=r.data.list.allVideos;
					console(this.newDramas);
				});
				Fetch('/index/int').then((r) => {
					block: {
						if (r.data.popup.show == 1) {
							var popup_show = sessionStorage.getItem("popup_show");
							sessionStorage.setItem("popup_show", r.data.popup.num);
							if (popup_show != null && popup_show == 1) {
								break block;
							}
							this.tc_content = r.data.popup.content;
							this.show_tc = true;
						}
					}
					this.loading = true;
					this.app = r.data.version;
					this.new_list = r.data.new_list;
					this.service = r.data.service;
					this.showApp();
				});
			},sortBys(a){
				this.sortBy=a;
				Fetch('/index/item_juji', {
					page: this.page,
					listRows: this.listRows,
					type: this.active,
					sortBy:this.sortBy,
				}).then(r => {
					
					this.allVideos=r.data.list.allVideos;
					console(this.newDramas);
				});
			},qiehuan(id){
				this.active = id;
				Fetch('/index/item_juji', {
					page: this.page,
					listRows: this.listRows,
					type: this.active,
					sortBy:this.sortBy,
				}).then(r => {
					
					this.allVideos=r.data.list.allVideos;
					console(this.newDramas);
				});
			},
			sort(index) {
				this.page = 1;
				this.empty = false;
				this.list = [];
				this.finished = false;
				this.loading = true;
				this.onLoad();
			},
			onLoad() {
				Fetch('/index/item_list', {
					page: this.page,
					listRows: this.listRows,
					type: this.tabs[this.active]['id']
				}).then(r => {
					if (r.data.length == 0) this.empty = true;
					var list = r.data.list;
					for (var i = 0; i < list.length; i++) {
						this.list.push(list[i]);
					}
					if (this.list.length >= r.data.length) {
						this.finished = true;
						return;
					}
					this.page = this.page + 1;
					this.loading = false;
				});
			}
		}
	};
</script>

<style lang="less" scoped>
	.home_wrap {
		margin-bottom: 60px;
		
		padding-top: 68px;
		height: 100%;
		min-height: 100vh;
		background-color: var(--bg-primary);
		color: var(--text-primary);
	
	
	}
	
	.red_top_bg {
		position: fixed !important;
		top: 0;
		left: 0;
		right: 0;
		z-index: 100000 !important;
		height: 68px;
		padding: 10px 0;
		background: hsla(0, 0%, 100%, .96);
		border-bottom: 1px solid #edf0f6;
		box-shadow: 0 2px 14px rgba(35, 65, 112, .06);
		
		-webkit-transform: translateZ(0);
		transform: translateZ(0);
		.logo {
			position: absolute;
			top: 10px;
			left: 3%;
			height: 48px;
		
			img {
				height: 100%;
			}
		}
		.language {
			position: absolute;
			top: 19px;
			right: 2%;
			height: 36px;
		
			img {
				height: 100%;
			}
		}
	}
	
	        /* ========== 搴曢儴�艰�========== */
	        .bottom-nav {
	            position: fixed;
	            bottom: 0;
	            left: 50%;
	            transform: translateX(-50%);
	            width: 100%;
	            max-width: 430px;
	            background: rgba(8, 8, 12, 0.96);
	            backdrop-filter: blur(28px);
	            -webkit-backdrop-filter: blur(28px);
	            border-top: 1px solid var(--border);
	            display: flex;
	            justify-content: space-around;
	            align-items: center;
	            padding: 10px 0 calc(10px + var(--safe-bottom));
	            z-index: 200;
	        }
	        .nav-tab {
	            display: flex;
	            flex-direction: column;
	            align-items: center;
	            gap: 5px;
	            cursor: pointer;
	            color: var(--text-muted);
	            transition: all 0.2s ease;
	            font-size: 10px;
	            font-weight: 500;
	            min-width: 52px;
	            padding: 6px 0;
	            letter-spacing: 0.02em;
	        }
	        .nav-tab .tab-icon {
	            font-size: 22px;
	            transition: transform 0.25s ease;
	        }
	        .nav-tab.active {
	            color: #fff;
	            font-weight: 700;
	        }
	        .nav-tab.active .tab-icon {
	            transform: translateY(-2px);
	        }
	        .nav-tab:active {
	            opacity: 0.6;
	        }
	/* ========== 鍒嗙被鏍囩 ========== */
	        .genre-scroll-wrap {
	            padding: 0 16px;
	            margin-bottom: 8px;
	            overflow: hidden;
	        }
	        .genre-scroll {
	            display: flex;
	            flex-wrap: nowrap;
	            gap: 10px;
	            overflow-x: auto;
	            overflow-y: hidden;
	            scroll-behavior: smooth;
	            -webkit-overflow-scrolling: touch;
	            touch-action: pan-x;
	            -ms-overflow-style: none;
	            scrollbar-width: none;
	            padding: 8px 2px 12px;
	            white-space: nowrap;
	            width: 100%;
	        }
	        .genre-scroll::-webkit-scrollbar {
	            display: none;
	        }
	        .genre-tag {
	            flex: 0 0 auto;
	            flex-shrink: 0;
	            padding: 10px 20px;
	            border-radius: 22px;
	            font-size: 13px;
	            font-weight: 600;
	            cursor: pointer;
	            background: var(--bg-card);
	            color: var(--text-secondary);
	            border: 1px solid var(--border);
	            transition: all 0.25s ease;
	            white-space: nowrap;
	            letter-spacing: 0.01em;
	        }
	        .genre-tag.active {
	            background: #fff;
	            color: #000;
	            border-color: #fff;
	            font-weight: 700;
	            box-shadow: 0 4px 20px rgba(255, 255, 255, 0.2);
	        }
	        .genre-tag:active {
	            transform: scale(0.95);
	        }
	        
	.list-header {
	            display: flex;
	            align-items: center;
	            justify-content: space-between;
	            padding: 20px 20px 8px;
	        }
	        .list-header h1 {
	            font-size: 24px;
	            font-weight: 900;
	            letter-spacing: -0.5px;
	            color: #fff;
	        }
	        .sort-btns {
	            display: flex;
	            gap: 6px;
	        }
	        .sort-btn {
	            padding: 8px 14px;
	            border-radius: 20px;
	            font-size: 12px;
	            font-weight: 600;
	            cursor: pointer;
	            background: var(--bg-card);
	            color: var(--text-secondary);
	            border: 1px solid var(--border);
	            transition: all 0.2s;
	            white-space: nowrap;
	            letter-spacing: 0.01em;
	        }
	        .sort-btn.active {
	            background: #fff;
	            color: #000;
	            border-color: #fff;
	            font-weight: 700;
	        }
	        .sort-btn:active {
	            transform: scale(0.95);
	        }
	
	        /* ========== 分类标签 ========== */
	        .genre-scroll-wrap {
	            padding: 0 16px;
	            margin-bottom: 6px;
	        }
	        .genre-scroll {
	            display: flex;
	            gap: 10px;
	            overflow-x: auto;
	            scroll-behavior: smooth;
	            -webkit-overflow-scrolling: touch;
	            touch-action: pan-x;
	            -ms-overflow-style: none;
	            scrollbar-width: none;
	            padding: 6px 2px 10px;
	        }
	        .genre-scroll::-webkit-scrollbar {
	            display: none;
	        }
	        .genre-tag {
	            flex-shrink: 0;
	            padding: 10px 20px;
	            border-radius: 22px;
	            font-size: 13px;
	            font-weight: 600;
	            cursor: pointer;
	            background: var(--bg-card);
	            color: var(--text-secondary);
	            border: 1px solid var(--border);
	            transition: all 0.25s ease;
	            white-space: nowrap;
	            letter-spacing: 0.01em;
	        }
	        .genre-tag.active {
	            background: #fff;
	            color: #000;
	            border-color: #fff;
	            font-weight: 700;
	            box-shadow: 0 4px 20px rgba(255, 255, 255, 0.2);
	        }
	        .genre-tag:active {
	            transform: scale(0.95);
	        }
	
	        /* ========== 视频卡片网格 ========== */
	        .video-grid {
	            display: grid;
	            grid-template-columns: repeat(2, 1fr);
	            gap: 14px;
	            padding: 8px 16px;
	        }
	        .video-card {
	            background: var(--bg-card);
	            border-radius: var(--radius-lg);
	            overflow: hidden;
	            cursor: pointer;
	            border: 1px solid var(--border);
	            transition: all 0.3s ease;
	            position: relative;
	            box-shadow: var(--shadow-card);
	        }
	        .video-card:active {
	            transform: scale(0.96);
	            border-color: rgba(255, 255, 255, 0.18);
	            box-shadow: var(--shadow-elevated);
	        }
	        .card-thumb {
	            width: 100%;
	            aspect-ratio: 16 / 10;
	            position: relative;
	            overflow: hidden;
	        }
	        .thumb-img {
	            position: absolute;
	            top: 0;
	            left: 0;
	            width: 100%;
	            height: 100%;
	            object-fit: cover;
	            display: block;
	            transition: transform 0.4s ease;
	        }
	        .video-card:active .thumb-img {
	            transform: scale(1.03);
	        }
	        .card-thumb .play-icon-overlay {
	            position: absolute;
	            inset: 0;
	            background: rgba(0, 0, 0, 0.4);
	            display: flex;
	            align-items: center;
	            justify-content: center;
	            opacity: 0;
	            transition: opacity 0.3s ease;
	            z-index: 2;
	        }
	        .video-card:active .play-icon-overlay {
	            opacity: 1;
	        }
	        .play-icon-overlay .circle {
	            width: 40px;
	            height: 40px;
	            border-radius: 50%;
	            background: rgba(255, 255, 255, 0.95);
	            display: flex;
	            align-items: center;
	            justify-content: center;
	            font-size: 14px;
	            color: #000;
	            box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);
	        }
	        .card-info {
	            padding: 12px 14px 14px;
	        }
	        .card-info h4 {
	            font-size: 14px;
	            font-weight: 600;
	            margin-bottom: 5px;
	            white-space: nowrap;
	            overflow: hidden;
	            text-overflow: ellipsis;
	            letter-spacing: -0.01em;
	            color: #fff;
	        }
	        .card-info .meta-text {
	            font-size: 12px;
	            color: var(--text-muted);
	            display: flex;
	            align-items: center;
	            gap: 7px;
	            font-weight: 500;
	        }
	        .card-info .meta-text .dot-sep {
	            width: 3px;
	            height: 3px;
	            background: var(--text-muted);
	            border-radius: 50%;
	        }
	        .new-badge {
	            position: absolute;
	            top: 10px;
	            left: 10px;
	            background: var(--accent);
	            color: #fff;
	            font-size: 10px;
	            font-weight: 700;
	            padding: 4px 10px;
	            border-radius: 12px;
	            z-index: 3;
	            letter-spacing: 0.04em;
	            text-transform: uppercase;
	        }
	        .duration-badge {
	            position: absolute;
	            bottom: 10px;
	            right: 10px;
	            background: rgba(0, 0, 0, 0.7);
	            color: #fff;
	            font-size: 10px;
	            font-weight: 600;
	            padding: 3px 8px;
	            border-radius: 10px;
	            z-index: 3;
	        }
	
	        /* ========== 加载更多 ========== */
	        .load-more-wrap {
	            display: flex;
	            justify-content: center;
	            padding: 20px 0 10px;
	        }
	        .load-more-btn {
	            background: var(--bg-card);
	            border: 1px solid var(--border);
	            color: var(--text-secondary);
	            padding: 12px 32px;
	            border-radius: 24px;
	            font-size: 13px;
	            font-weight: 600;
	            cursor: pointer;
	            transition: all 0.2s;
	            letter-spacing: 0.01em;
	        }
	        .load-more-btn:active {
	            background: #1e1e28;
	            border-color: rgba(255, 255, 255, 0.2);
	            color: #fff;
	            transform: scale(0.96);
	        }
	
	        /* ========== 底部导航 ========== */
	        .bottom-nav {
	            position: fixed;
	            bottom: 0;
	            left: 50%;
	            transform: translateX(-50%);
	            width: 100%;
	            max-width: 430px;
	            background: rgba(8, 8, 12, 0.96);
	            backdrop-filter: blur(28px);
	            -webkit-backdrop-filter: blur(28px);
	            border-top: 1px solid var(--border);
	            display: flex;
	            justify-content: space-around;
	            align-items: center;
	            padding: 10px 0 calc(10px + var(--safe-bottom));
	            z-index: 200;
	        }
	        .nav-tab {
	            display: flex;
	            flex-direction: column;
	            align-items: center;
	            gap: 5px;
	            cursor: pointer;
	            color: var(--text-muted);
	            transition: all 0.2s ease;
	            font-size: 10px;
	            font-weight: 500;
	            min-width: 52px;
	            padding: 6px 0;
	            letter-spacing: 0.02em;
	        }
	        .nav-tab .tab-icon {
	            font-size: 22px;
	            transition: transform 0.25s ease;
	        }
	        .nav-tab.active {
	            color: #fff;
	            font-weight: 700;
	        }
	        .nav-tab.active .tab-icon {
	            transform: translateY(-2px);
	        }
	        .nav-tab:active {
	            opacity: 0.6;
	        }
	
	        /* ========== Toast ========== */
	        .toast {
	            position: fixed;
	            top: 50%;
	            left: 50%;
	            transform: translate(-50%, -50%) scale(0.85);
	            background: rgba(28, 28, 38, 0.96);
	            color: #fff;
	            padding: 14px 28px;
	            border-radius: 28px;
	            font-size: 14px;
	            font-weight: 600;
	            z-index: 999;
	            pointer-events: none;
	            opacity: 0;
	            transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
	            white-space: nowrap;
	            letter-spacing: 0.01em;
	            box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
	        }
	        .toast.show {
	            opacity: 1;
	            transform: translate(-50%, -50%) scale(1);
	        }
	
	        /* 占位背景�*/
	        .bg-g-1 { background: #1c1a2e; }
	        .bg-g-2 { background: #151d2e; }
	        .bg-g-3 { background: #251a1e; }
	        .bg-g-4 { background: #1d1d16; }
	        .bg-g-5 { background: #142520; }
	        .bg-g-6 { background: #141d24; }
	        .bg-g-7 { background: #2a1a2e; }
	        .bg-g-8 { background: #1a2a2e; }
</style>
